import React from "react";
import PropTypes from "prop-types";
import style from "./styles";

const PremierButton = React.forwardRef((props, ref) => (
  <div className={style.PremierButton}>
    <button
      aria-label="Change Premier Country"
      ref={ref}
      onClick={props.onClick}
    >
      {props.buttonText}
    </button>
  </div>
));

PremierButton.displayName = "PremierButton";

PremierButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  buttonText: PropTypes.string.isRequired,
};

export default PremierButton;
